import React, { useState, useEffect, useCallback } from "react"
import OrganizationsApi from "../../services/organizations";
import NetworkApi from "../../services/networks";
import OrganizationsTable from "../../tables/OrganizationsTable"
import DashboardHeader from '../../components/DashboardHeader';
import { PopupboxContainer } from 'react-popupbox';
import LetterFilter from "../../components/LetterFilter";
import Pagination from "../../components/Pagination"

function OrganizationsPage(props) {
    const [organizations, setOrganizations] = useState([]);
    const [search, setSearch] = useState('');
    const [searchCity, setSearchCity] = useState('');
    const [searchStatus, setSearchStatus] = useState('All');
    const [selectedNetwork, setSelectedNetwork] = useState('');
    const [networks, setNetworks] = useState([]);
    const [totalPages, setTotalPages] = useState(0);
    const [pageItemActive, setPageItemActive] = useState(1);
    const [activeLetter, setActiveLetter] = useState('all'); 

    const fetch = useCallback(async() => {
        const organizationsApi = new OrganizationsApi(props.token);
        try {
            if (selectedNetwork && selectedNetwork !== '') {
                let response = await organizationsApi.searchByNetwork(selectedNetwork, searchStatus, '0', pageItemActive);
                setOrganizations(response.organizations);
                setTotalPages(response.total_pages);
            }
            else if(search && searchCity ){
                let response = await organizationsApi.searchByCity(searchCity, searchStatus,'0', pageItemActive)
                    let filteredData = response.organizations.filter((org) => org.name.toLowerCase().includes(search.toLowerCase()))
                    setOrganizations([...filteredData]);
                    setTotalPages(response.total_pages);
            }
            else if (searchCity ) {
                let response = await  organizationsApi.searchByCity(searchCity, searchStatus, '0', pageItemActive)
                setOrganizations(response.organizations);
                setTotalPages(response.total_pages);
            }
            else if (activeLetter && activeLetter !== 'all') {
                let response = await organizationsApi.filterByLetter(searchStatus, activeLetter,'0',  pageItemActive);
                setOrganizations(response.organizations);
                setTotalPages(response.total_pages);
            }   
            else if (search) {
                let response = await organizationsApi.search(search, searchStatus,'0', pageItemActive)
                setOrganizations(response.organizations);
                setTotalPages(response.total_pages);
            }
            else{
                let response = await organizationsApi.all(searchStatus,'0', pageItemActive)
                setOrganizations(response.organizations);
                setTotalPages(response.total_pages);
                if(!search && !searchCity){
                    setActiveLetter('all');
                }
            }
        } catch (error) {
            console.error(error);
            setOrganizations([]);
        }
    }, [selectedNetwork, search, searchCity, searchStatus, activeLetter, pageItemActive, props.token])

    useEffect(()=>{
        fetch()
    },[fetch])

    const fetchNetworks = useCallback(async () => {
        const networkApi = new NetworkApi(props.token);
        try {
            const response = await networkApi.all("Published", 1);
            setNetworks(response.networks || []);
        } catch (error) {
            console.error('Error fetching networks:', error);
            setNetworks([]);
        }
    }, [props.token]);

    useEffect(() => {
        fetchNetworks();
    }, [fetchNetworks]);


    const __handleSearch = (event) => {
        setSearch(event.target.value);
        setActiveLetter('');
        setSelectedNetwork('');
    };

    const handleSearchByCity =(event)=>{
        let value = event.target.value;
        setSearchCity(value);
        setActiveLetter('');
        setSelectedNetwork('');
    }

    const handleSearchByStatus =(event)=>{
        let value = event.target.value;
        setSearchStatus(value);
    }

    const handleNetworkChange = (event) => {
        setSelectedNetwork(event.target.value);
        setSearch('');
        setSearchCity('');
        setActiveLetter('');
    }
  
    const handleLetterClick = (letter) => {
        setSearch('')
        setSearchCity('')
        setSelectedNetwork('')
        setPageItemActive(1); 
        if(letter === 'all'){
            setActiveLetter('all'); 
        }else{
            setActiveLetter(letter); 
        }
      };

    const handleSelectPage=(pageNumber)=>{
        setPageItemActive(pageNumber);
    }
    
    return (
        <div className='dashboard-content'>
            <DashboardHeader
                btnText="New Organization" link='/organization/new' />
            <div className='dashboard-content-container'>
                <div className='dashboard-content-header'>
                    <h2>Organizations</h2>
                    <div>
                        <div className='dashboard-content-search mx-2'>
                            <select                                
                                value={searchStatus}                                
                                className='dashboard-content-input search-status-input'
                                onChange={e => handleSearchByStatus(e)} >                                
                                <option value="All">All</option>    
                                <option value="Published">Published</option>    
                                <option value="Unpublished">Unpublished</option>
                            </select>
                        </div>
                        <div className='dashboard-content-search'>
                            <input
                                type='text'
                                value={search}
                                placeholder='Search by name..'
                                className='dashboard-content-input'
                                onChange={e => __handleSearch(e)} />
                        </div>
                        <div className='dashboard-content-search search-city-input'>
                            <input
                                type='text'
                                value={searchCity}
                                placeholder='Search by city..'
                                className='dashboard-content-input'
                                onChange={e => handleSearchByCity(e)} />
                        </div>
                        <div className='dashboard-content-search search-city-input'>
                            <select
                                value={selectedNetwork}
                                className='dashboard-content-input'
                                onChange={e => handleNetworkChange(e)}>
                                <option value=''>Filter by Network</option>
                                {networks.map((network) => (
                                    <option key={network.id} value={network.id}>
                                        {network.name}
                                    </option>
                                ))}
                            </select>
                        </div>
                    </div>
                </div>
                <LetterFilter activeLetter={activeLetter} onLetterClick={handleLetterClick}/>
                <div className="organizations-custom-popup">
                    <PopupboxContainer />
                </div>
                    {
                        organizations.length > 0 ?
                            <OrganizationsTable organizations={organizations} {...props} refresh={fetch} />
                            :
                            <div className='dashboard-content-footer'>
                                <span className='empty-table'>No data</span>
                            </div>
                    }
                <Pagination totalPages={totalPages} pageItemActive={pageItemActive} handleSelectItem={handleSelectPage}/>
            </div>
        </div>
    )
}

export default OrganizationsPage